import React from "react";
import {
  Home,
  Users,
  FileText,
  DollarSign,
  AlertTriangle,
  Settings,
} from "lucide-react";

const Sidebar = ({ activeTab, setActiveTab, userRole }) => {
  const adminMenuItems = [
    { id: "dashboard", label: "Dashboard", icon: Home },
    { id: "members", label: "Members", icon: Users },
    { id: "policies", label: "Policies", icon: FileText },
    { id: "claims", label: "Claims", icon: FileText },
    { id: "payments", label: "Payments", icon: DollarSign },
    { id: "fraud", label: "Fraud Management", icon: AlertTriangle },
    { id: "settings", label: "Settings", icon: Settings },
  ];

  const memberMenuItems = [
    { id: "dashboard", label: "Dashboard", icon: Home },
    { id: "policies", label: "My Policies", icon: FileText },
    { id: "claims", label: "My Claims", icon: FileText },
    { id: "settings", label: "Settings", icon: Settings },
  ];

  const menuItems = userRole === "admin" ? adminMenuItems : memberMenuItems;

  return (
    <aside className="w-64 bg-white shadow-sm border-r h-full">
      <nav className="mt-8">
        <ul className="space-y-2 px-4">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.id}>
                <button
                  onClick={() => setActiveTab(item.id)}
                  className={`w-full flex items-center px-4 py-3 text-left rounded-lg transition-colors ${
                    activeTab === item.id
                      ? "bg-blue-50 text-blue-700 border-r-2 border-blue-700"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                  }`}
                >
                  <Icon className="h-5 w-5 mr-3" />
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
